import { PopoverTrigger as OrigPopoverTrigger } from "@chakra-ui/react";

export const PopoverTrigger: React.FC<{ children: React.ReactNode }> =
  OrigPopoverTrigger;
